module.exports = __webpack_public_path__ + "static/story4-title-380x245-32dacaea6737ab41d7988aacb3e92a6e.svg";